import React, { useMemo } from "react";
import { Card, Typography, Button, Icon } from "@ann/web-components";
import {
  GroupsCardContainer,
  GroupsCardDescription,
  SelectedGroupsGrid,
  SelectedGroupCardContent,
  SelectedGroupInfo,
  SelectedGroupActions,
  ViewDetailsLink,
} from "./GroupsCard.styled";

const GroupsCard = ({ onAddGroups, selectedGroups, onRemoveGroup, groupsData = [] }) => {
  const hasSelections = Array.isArray(selectedGroups) && selectedGroups.length > 0;

  const selectedGroupDetails = useMemo(() => {
    if (!hasSelections) return [];

    // Create a map for quick lookup
    const groupsMap = new Map(groupsData.map((group) => [group.groupUuid, group]));

    return selectedGroups
      .map((groupId) => {
        const group = groupsMap.get(groupId);
        if (group) {
          return {
            id: group.groupUuid,
            title: group.name,
            description: group.description || "No description available.",
          };
        }
        // Show group with ID if data not available yet
        return {
          id: groupId,
          title: groupId,
          description: "Loading group details...",
        };
      });
  }, [hasSelections, selectedGroups, groupsData]);

  if (!hasSelections) {
    return (
      <Card size="medium">
        <GroupsCardContainer>
          <Typography category="title" size="small" weight="bold">
            No groups selected
          </Typography>
          <GroupsCardDescription>
            Add groups to organize users by team, department, or location. Groups don’t affect permissions but make management
            simpler.
          </GroupsCardDescription>
          <Button type="secondary" label="Add groups" size="medium" iconRight="plus" onClick={onAddGroups} />
        </GroupsCardContainer>
      </Card>
    );
  }

  return (
    <SelectedGroupsGrid>
      {selectedGroupDetails.map((group) => (
        <Card key={group.id} size="small" style={{ width: "100%", minHeight: "50px" }}>
          <SelectedGroupCardContent>
            <SelectedGroupInfo>
              <Typography category="title" size="small" weight="bold">
                {group.title}
              </Typography>
              <Typography category="body" size="small" weight="regular">
                {group.description}
              </Typography>
            </SelectedGroupInfo>
            <SelectedGroupActions>
              <ViewDetailsLink type="button">View details</ViewDetailsLink>
              <Icon name="close" onClick={() => onRemoveGroup(group.id)} style={{ cursor: "pointer" }} />
            </SelectedGroupActions>
          </SelectedGroupCardContent>
        </Card>
      ))}
    </SelectedGroupsGrid>
  );
};

export default GroupsCard;

